import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import textBodySStrong from '@fukku/styles/texts/textBodySStrong.module.css'
import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'
import { cx } from 'classix'
import styles from './BannerTitles.module.css'

interface TitlesProps {
	readonly discount?: string
	readonly title?: string
	readonly subtitle?: string | React.ReactNode
	readonly subtitlesGroup?: {
		titleKey: string
		subtitleKey: string
	}[]
	readonly isInverse?: boolean
}

const showTitles = ({
	discount,
	title,
	subtitle,
	subtitlesGroup,
}: TitlesProps) => {
	const hasSubtitlesGroup = subtitlesGroup && subtitlesGroup?.length > 0
	return (
		Boolean(title) ||
		Boolean(subtitle) ||
		Boolean(discount) ||
		Boolean(hasSubtitlesGroup)
	)
}

export const BannerTitles = ({
	discount,
	title,
	subtitle,
	subtitlesGroup,
	isInverse,
}: TitlesProps) => {
	const showBannerTitles = showTitles({
		title,
		subtitle,
		discount,
		subtitlesGroup,
	})

	return showBannerTitles ? (
		<div className={cx(styles.titles, isInverse && styles.inverse)}>
			{(title || discount) && (
				<h2 className={cx(styles.title, textHeadingM.className)}>
					{title && <span>{title}</span>}
					{discount && <span>{discount}</span>}
				</h2>
			)}
			{subtitlesGroup?.map(({ titleKey, subtitleKey }) => (
				<div
					className={styles.subtitlesGroup}
					key={`${titleKey}-${subtitleKey}`}
				>
					<span className={textBodySStrong.className}>{titleKey}</span>
					<span className={textBodyS.className}>{subtitleKey}</span>
				</div>
			))}
			{subtitle && (
				<h3 className={cx(styles.subtitle, textBodyS.className)}>{subtitle}</h3>
			)}
		</div>
	) : null
}
